module.exports = ".menu__container {\n  padding-right: 0;\n  padding-left: 0; }\n"